import React from 'react';
import { FiCheckCircle, FiMinusCircle } from 'react-icons/fi';
import { Popup } from 'semantic-ui-react';

interface Props {
    isApproved?: ?boolean;
}

export class IsApprovedStatusIcon extends React.PureComponent<Props> {
    render() {
        const { isApproved } = this.props;
        if (isApproved) {
            return (
                <Popup
                    trigger={
                        <FiCheckCircle
                            size={22}
                            className="text pink"
                            style={{ verticalAlign: 'middle' }}
                        />
                    }
                    content="Approved"
                    inverted
                    basic
                    position="top center"
                />
            );
        }
        return (
            <Popup
                trigger={
                    <FiMinusCircle
                        size={22}
                        className="text grey"
                        style={{ verticalAlign: 'middle' }}
                    />
                }
                content="Not approved"
                inverted
                basic
                position="top center"
            />
        );
    }
}

export default IsApprovedStatusIcon;
